<script>
import Input from "@/pages/components/form/horizontal/input.vue";
import FormGroup from "@/pages/components/form/horizontal/form-group.vue";

export default {
  components: {Input, FormGroup},
  inheritAttrs: false,
  emits: ['update:modelValue'],
  props: {
    'modelValue': {
      required: true,
    },
    'name': {
      required: true,
      type: String,
    },
    'label': {
      required: true,
      type: String,
    },
    'options': {
      type: Array,
      default: [],
    },
    'required': {
      type: Boolean,
      default: true,
    },
    'groupClasses': {
      type: String,
      default: ''
    },
  },
}
</script>

<template>
  <FormGroup :group-classes="groupClasses">
    <template #label>{{ label }}</template>
    <select class="form-control" :name="name" :id="name" :required="required" @update:modelValue="this.$emit('update:modelValue', $event)">
      <option v-for="option in options" :selected="modelValue == option" :value="option">{{ option }}</option>
    </select>
  </FormGroup>
</template>